module.exports = __webpack_public_path__ + "assets/images/project/icon/4g_icon.svg?v=fd849a34";